import { eventsUrl } from "../../constant";

export const footerItems = [
  {
    title: "PRODUCTS",
    items: [
      "Crypto",
      "Giftcard",
      "Bills Payments",
      { label: "Events", href: eventsUrl, external: true },
    ],
  },
  {
    title: "COMPANY",
    items: ["About", "Privacy Policy", "Terms and Conditions"],
    link: true,
  },
  {
    title: "CONTACT US",
    items: [
      "LASU OJO, Lagos, Nigeria.",
      "+234 810 551 3417",
      "support@asapuu.com",
    ],
  },
];
